import React from 'react'

const SmallLogo = () => {
   return (
      <span>
         <img
            alt="thai2english-logo"
            className="light-logo inline-block align-middle min-[320px]:mr-[10px] min-[320px]:w-[27px] md:mr-[15px] md:w-[34px]"
            crossOrigin="anonymous"
            src="/logo/png/t2e-symbol-light.png"
         />
         <img
            alt="thai2english-logo"
            className="dark-logo inline-block align-middle min-[320px]:mr-[10px] min-[320px]:w-[27px] md:mr-[15px] md:w-[34px]"
            crossOrigin="anonymous"
            src="/logo/png/t2e-symbol-dark.png"
         />
      </span>
   )
}

export default SmallLogo
